(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
  console.log('Loaded!');
  const productForm = document.querySelector('product-form');
  console.log('productForm', productForm);
  const textMessageElement = document.querySelector('.textMessage.textMessage--information');
  console.log('textMessageElement', textMessageElement);

  const nowTimestamp = parseInt(productForm.dataset.nowTimestamp, 10);
  console.log('nowTimestamp ▶︎▶︎▶︎ ', nowTimestamp);
  const salesStatus = productForm.dataset.salesStatus;
  console.log('salesStatus：', salesStatus);
  const startTimestamp = parseInt(productForm.dataset.startTimestamp, 10);
  console.log('startTimestamp：', startTimestamp);
  const endTimestamp = parseInt(productForm.dataset.endTimestamp, 10);
  console.log('endTimestamp：', endTimestamp);
  const productAvailable = productForm.dataset.productAvailable === 'true'; // 文字列を真偽値に変換
  console.log('productAvailable：', productAvailable);
  const salesType = productForm.dataset.salesType;
  console.log('salesType：', salesType);

  const submitButton = document.getElementById(`ProductSubmitButton-${productForm.dataset.sectionId}`);

  // 各ステータスに対応するテキストを管理
  const statusTexts = {
    before: '販売開始前',
    active: 'カートに入れる',
    sold_out: 'Sold Out',
    ended: '販売終了',
    ended_stock: 'SOLD OUT', // 在庫販売 (通年販売) の販売終了
  };

  const updateButtonState = (status) => {
    console.log('販売状況：', status)
    console.log('updateButtonState!');
    if (!submitButton) return;

    // ボタンのテキストを更新
    let buttonText = '';
    let isDisabled = false;

    console.log('salesType＝＞', salesType)

    if (status === 'before') {
      console.log('before!!');
      buttonText = statusTexts.before;
      console.log('buttonText：', buttonText);
      isDisabled = true;
    } else if (status === 'active') {
      console.log('active!');
      buttonText = productAvailable ? statusTexts.active : statusTexts.sold_out;
      console.log('buttonText', buttonText);
      isDisabled = !productAvailable;
    } else if (status === 'ended') {
      console.log('ended!');
      if (salesType === '在庫販売 (通年販売)') {
        buttonText = statusTexts.sold_out;
      console.log('buttonText：', buttonText);
        isDisabled = true;
      } else {
        buttonText = statusTexts.ended;
        console.log('buttonText：', buttonText);
        isDisabled = true;
      }
    }

    submitButton.querySelector('span').textContent = buttonText;
    submitButton.disabled = isDisabled;
  };

  // タイムスタンプを監視し、ボタンの状態を更新する関数（時間判定を一元化）
  const checkTimeAndStatus = () => {
    // 【修正箇所】クライアント側の現在時刻（秒単位）を取得
    const nowTimestamp = Math.floor(Date.now() / 1000); 
    console.log('nowTimestamp ▶︎▶︎▶︎' , nowTimestamp)
    let currentStatus;

    // Liquidから取得した静的なタイムスタンプのみと比較
    if (startTimestamp && nowTimestamp < startTimestamp) {
      currentStatus = 'before';
    } else if (endTimestamp && nowTimestamp > endTimestamp) {
      // 終了時間を過ぎた場合の在庫販売（通年販売）の特殊ロジック
      if (salesType === '在庫販売 (通年販売)') {
        currentStatus = 'active'; // 在庫があればカート、なければSold Out
      } else {
        currentStatus = 'ended';
      }
    } else {
      currentStatus = 'active'; // 販売期間中
    }

    updateButtonState(currentStatus);
  };

  checkTimeAndStatus();
  setInterval(checkTimeAndStatus, 5000);
});
  } catch(e) { console.error(e); }
})();

})();
